// 帮助中心
import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 问题状态
 */
class HistoryDef extends UltMeta {
    // 小模块
    // 进销存管理-项目管理
    INVENTORY_PROJECT = new Meta(1, "进销存管理-项目管理");
    STORE_STOCK_CHECK = new Meta(2, "仓储管理-抽检管理");
    STORE_STOCKTAKING = new Meta(3, "仓储管理-盘点管理");
    STORE_PROJECT = new Meta(4, "仓储管理-项目管理");
    REVENUE_SETTLEMENT = new Meta(5, "收益结算");
    // 进销存管理-盘点管理
    DEAL_STOCKTAKING = new Meta(6, "进销存管理-盘点管理");
    // 仓储业务-项目管理
    STOCK_PROJECT = new Meta(7, "仓储业务-项目管理");
    // // 操作动作
    // // 进销存管理-项目管理 相关
    INVENTORY_PROJECT_ADD = new Meta("新增", "新增");
    INVENTORY_PROJECT_MODIFY = new Meta("修改", "修改");
    INVENTORY_PROJECT_APPLY_FINISH = new Meta("申请完结", "申请完结");
    INVENTORY_PROJECT_CONFIRM_FINISH = new Meta("确认完结", "确认完结");

    // 仓储管理-抽检管理 相关
    STORE_STOCK_CHECK_ADD = new Meta("新增", "新增");
    STORE_STOCK_CHECK_MODIFY = new Meta("修改", "修改");

    // 仓储管理-盘点管理 相关
    STORE_STOCKTAKING_ADD = new Meta("新增", "新增");
    STORE_STOCKTAKING_MODIFY = new Meta("修改", "修改");

    // 仓储管理-项目管理 相关
    STORE_PROJECT_ADD = new Meta("新增", "新增");
    STORE_PROJECT_MODIFY = new Meta("修改", "修改");
    STORE_PROJECT_APPLY_FINISH = new Meta("申请完结", "申请完结");
    STORE_PROJECT_CONFIRM_FINISH = new Meta("确认完结", "确认完结");
}

export const HISTORY_DEF = new HistoryDef();
